import script from "./WilliamsR.vue?vue&type=script&lang=js"
export * from "./WilliamsR.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__